import React from 'react'
import { useIntl } from 'react-intl'
import { ErrorMessage, StyledContainer } from './styles'
import { Spinner } from '../../../../assets/icons'
import { useSelector } from 'react-redux'
import type { RootState } from 'shared/store/reducers'
import { StyledEndedContainer } from './TPKDone'

export const LoadingCodeCheck = () => {
    const error = useSelector((s: RootState) => s.tuPreferesKingState.error)
    const intl = useIntl()
    return (
        <StyledContainer>
            <StyledEndedContainer>
                {error ? (
                    <ErrorMessage>
                        {intl.formatMessage({
                            id: 'tupreferesking.errors.' + error
                        })}
                    </ErrorMessage>
                ) : (
                    <p>
                        <Spinner />
                    </p>
                )}
            </StyledEndedContainer>
        </StyledContainer>
    )
}
